import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { Icon, TextButton } from '../../atoms';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Notification = ({ type, text, ...props }) => {
  const iconColor = type === 'primary' ? 'white' : 'dark';

  return (
    <Wrapper {...props}>
      <TextButton size="100%" bgColor={type} contentPosition="space-between">
        {text}
        <Icon name="chevron-right" color={iconColor} />
      </TextButton>
    </Wrapper>
  );
};

Notification.defaultProps = {
  type: 'primary',
};

Notification.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary']),
  text: PropTypes.string.isRequired,
};

export default Notification;
